import { CleanDeliveryMethod } from '../../../export-types/cleaned-types';
import { SortType } from 'rsuite/Table';
import { ProductCategory } from '../../../consts/db-values';

export const compareNumberValues = (
  a: CleanDeliveryMethod,
  b: CleanDeliveryMethod,
  field: keyof CleanDeliveryMethod,
  sortType: SortType,
): number => {
  const aValueRaw = a?.[field];
  const bValueRaw = b?.[field];

  if (aValueRaw == null && bValueRaw == null) return 0;
  if (aValueRaw == null) return 1;
  if (bValueRaw == null) return -1;

  const aValue =
    typeof aValueRaw === 'string' ? parseFloat(aValueRaw) : aValueRaw;
  const bValue =
    typeof bValueRaw === 'string' ? parseFloat(bValueRaw) : bValueRaw;

  if (typeof aValue === 'number' && typeof bValue === 'number') {
    return sortType === 'asc' ? aValue - bValue : bValue - aValue;
  }

  return 0;
};

export const compareStrings = (
  a: CleanDeliveryMethod,
  b: CleanDeliveryMethod,
  field: keyof CleanDeliveryMethod,
  sortType: SortType,
  orderCategories: Record<ProductCategory, string>,
): number => {
  let stringA: string;
  let stringB: string;

  if (field === 'productCategories') {
    const labelsA = a.productCategories
      .map((c) => orderCategories[c as ProductCategory] || '')
      .join(', ');
    const labelsB = b.productCategories
      .map((c) => orderCategories[c as ProductCategory] || '')
      .join(', ');

    stringA = labelsA.trim().toLowerCase();
    stringB = labelsB.trim().toLowerCase();
  } else {
    const valueA = field === 'destination' ? a.destination?.name : a[field];
    const valueB = field === 'destination' ? b.destination?.name : b[field];

    stringA = String(valueA)?.trim().toLowerCase() || '';
    stringB = String(valueB)?.trim().toLowerCase() || '';
  }

  const comparisonResult = stringA.localeCompare(stringB, 'ru');

  return sortType === 'asc' ? comparisonResult : -comparisonResult;
};

export const compareBooleanValues = (
  a: CleanDeliveryMethod,
  b: CleanDeliveryMethod,
  field: keyof CleanDeliveryMethod,
  sortType: SortType,
): number => {
  const valueA = a[field];
  const valueB = b[field];
  if (valueA === null || valueA === undefined)
    return sortType === 'asc' ? -1 : 1;
  if (valueB === null || valueB === undefined)
    return sortType === 'asc' ? 1 : -1;

  if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
    return sortType === 'asc'
      ? Number(valueA) - Number(valueB)
      : Number(valueB) - Number(valueA);
  }

  return 0;
};
